// THIS IS A COPY OF COMPLETED TO BE MODIFIED FOR NEW STATUS OF SHIPPED
// NEED TO ADD FUNCTIONALITY TO SET STATUS TO COMPLETED

import { Table, InputGroup, Button, Input } from 'reactstrap';
import { useState, useEffect } from 'react'
import { useSelector } from "react-redux"
import OrderSummary from './parts/OrderSummary'
import Contact from './parts/Contact'
import CustomizationSummary from './parts/CustomizationSummary'
import PauseControl from './parts/PauseControl'
//import CompletedStatusControl from './parts/CompletedStatusControl'
import Pagination from './parts/Pagination'
import { formatDate } from './parts/helperFunctions'
import { FaSort, FaDownload } from "react-icons/fa";
import './Shipped.scss';


function Shipped(props) {

	const [retailProNums, setRetailProNums] = useState({})

	const products = useSelector(state => state.product.balls)
	const orders = useSelector(state => state.console.orders)
				   .filter(p => (p.Status === 'SHIPPED') && (p.Paused === false))

	const [dateSortForward, setDateSortForward] = useState(true)
	const [sortedOrders, setSortedOrders] = useState([])

	const sortOrders = () => {
		setSortedOrders ( orders.sort(function(a, b) {
		    var c = new Date(a.Updated);
		    var d = new Date(b.Updated);
		    return dateSortForward ? c-d : d-c;
		}) )
	}

	useEffect(()=>{
		sortOrders()
	},[dateSortForward, orders.length])

	const handleNewUpdate = (e) => {
      e.preventDefault();
	  const formData = new FormData(e.target);
	  const formProps = Object.fromEntries(formData);
	}

	return (
	    <div className="dashboard-inbound">

			<Table className="inbound-table" responsive striped >
			  <thead>
			    <tr>
			      <th className='sortable' onClick={()=>{setDateSortForward(!dateSortForward)}}>
			        Date <FaSort className='icons' />
			      </th>
			      <th>
			        Summary
			      </th>
			      <th>
			        Shipping
			      </th>
			      <th>
			        Product
			      </th>
			      <th>
			        Customizations
			      </th>
			      <th>
			        RetailPro&nbsp;#
			      </th>
			      <th>
			        Status
			      </th>
			    </tr>
			  </thead>

			  <tbody>
			  { sortedOrders.map((orderObj) => {

		  		const product = products.filter(product => product.ID === orderObj.ProductID)[0]

		  		return (
				    <tr key={orderObj.ID}>
				      <td>
				        {formatDate(orderObj.Updated)}
				      </td>
				      <td>
				        <OrderSummary orderObj={orderObj} context="INBOUND" />
				      </td>
				      <td>
				      	<Contact contactObj={orderObj.Billing.ShippingAddress} context="INBOUND" />
				      </td>
				      <td>
				        <p>
					        <b>{product.BrandName} {product.NameEN}</b>
						</p>
				      </td>
				      <td>
				      	<CustomizationSummary orderObj={orderObj} product={product} context="INBOUND" />
				      </td>
				      <td>
				        <p>
					        <b>{orderObj.RetailPro}</b>
						</p>
				      </td>
				      <td>
				        <p className='mt-2'>
							{/*<CompletedStatusControl orderObj={orderObj} context='PRODUCTION' />*/}
							<PauseControl orderObj={orderObj} context='PRODUCTION' />
						</p>
				      </td>
				    </tr>

					) })
			  }
			  </tbody>
			</Table>
			<Pagination />
		</div>
	)
}

export default Shipped